import React, { useState } from "react";
import { Star, MessageCircle, Instagram, User } from "lucide-react";

export default function Testimonials() {
  const [activeTab, setActiveTab] = useState("scritte");

  const stats = [
    { value: "240+", label: "Donne Accompagnate" },
    { value: "1,800+", label: "Ore di Coaching Individuale" },
    { value: "96.4%", label: "Tasso di Completamento" },
    { value: "99.2%", label: "Soddisfazione Clienti" }
  ];

  const writtenReviews = [
    {
      name: "Francesca, 34 anni",
      before: "Ero perennemente attaccata allo schermo del telefono, ansiosa ed in attesa di un suo minimo cenno. Sentivo di non valere nulla senza di lui.",
      transformation: "Oggi ho ripreso in mano la mia carriera, vivo da sola in un appartamento splendido e quando lo rivedo provo solo una grande indifferenza.",
      quote: "Giulia mi ha letteralmente restituito la mia vita. Ho smesso di elemosinare attenzioni.",
      stars: 5
    },
    {
      name: "Elena, 41 anni",
      before: "Accettavo relazioni segrete e comportamenti ambigui, pensando che prima o poi avrebbe scelto me. Mi stavo svuotando giorno dopo giorno.",
      transformation: "Ho imparato a stabilire confini chiari e rigidi. Ora sono felicemente fidanzata con un uomo meraviglioso che mi rispetta e mi sceglie ogni giorno.",
      quote: "Il metodo Feminine Return funziona perché non lavora sull'altro, ma guarisce te stessa all'origine.",
      stars: 5
    }
  ];

  const chatScreenshots = [
    {
      type: "WhatsApp",
      sender: "Martina L.",
      text: "Giulia volevo dirti che oggi per la prima volta l'ho incontrato al bar e non ho sentito quell'ansia allo stomaco. Sono passata oltre sorridendo. Grazie di cuore, non ci credo ancora!!! ❤️",
      date: "Ieri, 18:42"
    },
    {
      type: "Instagram",
      sender: "@alessandra_b",
      text: "Il percorso più bello e trasformativo che potessi mai fare. Ho smesso di rincorrere chi non c'era e ho iniziato a rincorrere i miei sogni. Sei un'anima preziosa Giulia.",
      date: "2 giorni fa"
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-beige font-sans">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-16">
        
        {/* Title */}
        <div className="text-center space-y-4 max-w-2xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
            TESTIMONIANZE REALI
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial">
            Storie di <span className="italic">rinascita</span>
          </h2>
          <p className="text-sm sm:text-base leading-relaxed text-chocolate/70 font-light">
            {"Nessuna recensione è manipolata o forzata. Ogni parola rappresenta una donna che ha avuto il coraggio di voltare pagina e ritrovare sé stessa."}
          </p>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 py-10 border-y border-chocolate/10 bg-white/50 backdrop-blur-sm">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center space-y-2">
              <span className="text-3xl sm:text-4xl font-editorial font-light text-bordeaux block">
                {stat.value}
              </span>
              <span className="text-xs font-semibold uppercase tracking-wider text-chocolate/60">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* Interactive Filters Tabs */}
        <div className="flex justify-center space-x-4 md:space-x-8 border-b border-chocolate/10 pb-4">
          <button 
            onClick={() => setActiveTab("scritte")}
            className={`text-xs sm:text-sm font-semibold tracking-wider pb-2 border-b-2 transition-luxury uppercase ${
              activeTab === "scritte" ? "border-bordeaux text-bordeaux" : "border-transparent text-chocolate/60"
            }`}
          >
            RECENSIONI SCRITTE
          </button>
          <button
            onClick={() => setActiveTab("screenshot")}
            className={`text-xs sm:text-sm font-semibold tracking-wider pb-2 border-b-2 transition-luxury uppercase ${
              activeTab === "screenshot" ? "border-bordeaux text-bordeaux" : "border-transparent text-chocolate/60"
            }`}
          >
            CHAT WHATSAPP & IG
          </button>
        </div>

        {/* Tab Contents */}
        <div className="min-h-[350px]">
          {/* 1. Written Reviews */}
          {activeTab === "scritte" && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-fade-in">
              {writtenReviews.map((rev, idx) => (
                <div key={idx} className="bg-white p-8 border border-chocolate/10 flex flex-col justify-between space-y-6">
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-beige flex items-center justify-center text-bordeaux">
                          <User className="w-5 h-5" />
                        </div>
                        <span className="text-sm font-semibold text-chocolate">{rev.name}</span>
                      </div>
                      <div className="flex space-x-1">
                        {[...Array(rev.stars)].map((_, sIdx) => (
                          <Star key={sIdx} className="w-4 h-4 fill-amber-500 text-amber-500" />
                        ))}
                      </div>
                    </div>
                    
                    <p className="font-editorial text-lg italic text-bordeaux leading-relaxed">
                      {"\""}{rev.quote}{"\""}
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs pt-4 border-t border-chocolate/10">
                      <div>
                        <span className="font-semibold text-red-800 uppercase tracking-widest block mb-1">PRIMA DEL PERCORSO</span>
                        <p className="text-chocolate/70 leading-relaxed font-light">{rev.before}</p>
                      </div>
                      <div>
                        <span className="font-semibold text-emerald-800 uppercase tracking-widest block mb-1">TRASFORMAZIONE</span>
                        <p className="text-chocolate/70 leading-relaxed font-light">{rev.transformation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* 2. Chat Screenshots */}
          {activeTab === "screenshot" && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-fade-in font-sans">
              {chatScreenshots.map((chat, idx) => (
                <div key={idx} className="bg-cream p-8 border border-chocolate/15 shadow-sm space-y-6 max-w-xl mx-auto w-full">
                  <div className="flex items-center justify-between border-b border-chocolate/10 pb-3">
                    <div className="flex items-center space-x-2">
                      {chat.type === "WhatsApp" ? (
                        <MessageCircle className="w-5 h-5 text-emerald-600" />
                      ) : (
                        <Instagram className="w-5 h-5 text-pink-600" />
                      )}
                      <span className="text-xs tracking-widest uppercase font-semibold text-chocolate/60">
                        {"MESSAGGIO SU "}{chat.type}
                      </span>
                    </div>
                    <span className="text-xs text-chocolate/40 font-mono">{chat.date}</span>
                  </div>

                  <div className="space-y-3">
                    <span className="text-xs font-semibold text-chocolate">{chat.sender}</span>
                    <p className="text-sm bg-white p-4 border border-chocolate/10 italic font-mono text-chocolate/80 leading-relaxed">
                      {"\""}{chat.text}{"\""}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </section>
  );
}
